import { processModel } from "@/_core/data/api_calls/relatives_values/model/processModel";

/**
 * Retrieves model data for currency relative values.
 *
 * @param {object} ctx - Context variables for the API call.
 * @returns {Promise<any>} - A promise resolving to the model data.
 */
export function getModelDataCurrencies(ctx) {
  const params = {
    method: "GET",
    endpoint: "relatives_values",
    content_type: "application/json",
    query_params: {
      format: "json",
      currency: ctx.currencyNumber
    }
  };

  return processModel(ctx, params);
}
